import type { ReactNode } from 'react';

interface StampProps {
  children: ReactNode;
  variant?: 'default' | 'positive' | 'critical' | 'suggestion';
}

/**
 * Carimbo discreto — bloco de metadado no canto, com borda dupla sutil.
 *
 * Usado em headers de relatório (ex: "GERADO · 2026-05-04") e topo de
 * blocos importantes. Estética de carimbo seco editorial, não badge SaaS.
 *
 * E5 (docs/01 §6): decoração funcional. Sinaliza que aquela informação é
 * "carimbada" no documento, não conteúdo.
 */
export function Stamp({ children, variant = 'default' }: StampProps) {
  const palette = paletteOf(variant);
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2 py-0.5 font-mono text-[10px] uppercase tracking-[0.15em]"
      style={{
        color: palette.fg,
        border: `1px solid ${palette.border}`,
        boxShadow: `inset 0 0 0 1px ${palette.bg}`,
      }}
    >
      {children}
    </span>
  );
}

function paletteOf(variant: NonNullable<StampProps['variant']>) {
  switch (variant) {
    case 'positive':
      return {
        fg: 'var(--accent-forest)',
        border: 'var(--accent-forest-border)',
        bg: 'var(--accent-forest-bg)',
      };
    case 'critical':
      return {
        fg: 'var(--accent-crimson)',
        border: 'var(--accent-crimson-border)',
        bg: 'var(--accent-crimson-bg)',
      };
    case 'suggestion':
      return {
        fg: 'var(--accent-saffron)',
        border: 'var(--accent-saffron-border)',
        bg: 'var(--accent-saffron-bg)',
      };
    default:
      return {
        fg: 'var(--ink-secondary)',
        border: 'var(--border-default)',
        bg: 'var(--bg-paper-elevated)',
      };
  }
}
